import { render, staticRenderFns } from "./AdditionalServicesTable.vue?vue&type=template&id=7a81dd4a&scoped=true&"
import script from "./AdditionalServicesTable.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicesTable.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServicesTable.vue?vue&type=style&index=0&id=7a81dd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a81dd4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDataTable})
